import React, { useEffect, useState } from 'react'
import { Button, Group, LoadingOverlay, Modal, ModalProps, Stack, TextInput } from '@mantine/core'
import { usePricingVersion, useUpdatePricingVersion } from '../../../hooks/global-job-matching'
import { notifications } from '@mantine/notifications'

interface RenameVersionModalProps extends ModalProps {
  versionId: number
}

export const RenameVersionModal = ({ opened, onClose, versionId }: RenameVersionModalProps) => {
  const [value, setValue] = useState('')
  const { data: version, isLoading  } = usePricingVersion(versionId.toString())
  const { mutate: updateVersion, isLoading: isUpdating, isSuccess, isError, reset } = useUpdatePricingVersion(versionId.toString())

  const handleUpdate = () => updateVersion({ name: value })

  useEffect(() => {
    if (version) setValue(version.name)
    if (!opened && version) setValue(version.name)
  }, [version, opened])

  if (isError) {
    notifications.show({ message: 'Unable to rename version. This version name may already exist', color: 'red' })
    reset()
  }

  if (isSuccess) {
    reset()
    onClose()
  }

  if (!version) return

  return (
    <Modal size='xl' title='Rename Version' opened={opened} onClose={onClose}>
      <LoadingOverlay visible={isLoading || isUpdating} />
      <Stack>
        <TextInput
          data-autofocus
          label='New Version Name'
          value={value}
          onChange={e => setValue(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') handleUpdate()
          }}
        />
        <Group mt='xl' justify='flex-end'>
          <Button variant='outline' onClick={onClose}>Cancel</Button>
          <Button onClick={handleUpdate}>Confirm</Button>
        </Group>
      </Stack>
    </Modal>
  )
}
